import PropTypes from 'prop-types';

import { fieldClasses } from '#globalComponents/Forms/fieldStyles';

export default function Textarea({ error = false, className = '', rows = 3, ...props }) {
	return (
		<textarea
			rows={rows}
			className={fieldClasses('rounded-card px-4 py-2.5 resize-y', Boolean(error), className)}
			{...props}
		/>
	);
}

Textarea.propTypes = {
	error: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
	className: PropTypes.string,
	rows: PropTypes.number,
};
